import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, Sparkles } from "lucide-react";

const MAX = 15;

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [state, setState] = useState({ status: "polling", tries: 0, data: null });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", tries: 0, data: null }); return; }
    let cancelled = false; let tries = 0;
    const poll = async () => {
      if (cancelled) return;
      try {
        const r = await api.get(`/featured/status/${sessionId}`);
        tries += 1;
        const d = r.data; const st = d.featured_status;
        if (st === "active") return setState({ status: "active", tries, data: d });
        if (st === "cancelled" || st === "refunded") return setState({ status: "failed", tries, data: d });
        if (tries >= MAX) return setState({ status: "timeout", tries, data: d });
        setState({ status: "polling", tries, data: d });
        setTimeout(poll, 2000);
      } catch { setState({ status: "error", tries, data: null }); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const d = state.data; const parent = d?.parent;
  const until = parent?.featured_ends_at || d?.featured_ends_at;
  return (
    <div className="page fade-up min-h-[70vh] flex items-center justify-center">
      <div data-testid="featured-success" data-state={state.status} className="max-w-md w-full text-center py-10">
        {state.status === "polling" && (<>
          <Loader2 className="mx-auto animate-spin text-zinc-400 mb-4" size={48} />
          <div className="font-display font-bold text-lg mb-2">A confirmar o pagamento com a Stripe…</div>
          <div className="text-sm text-zinc-500">O destaque ativa assim que a confirmação chegar. Tentativa {state.tries} de {MAX}</div>
        </>)}
        {state.status === "active" && (<>
          <CheckCircle2 className="mx-auto text-emerald-500 mb-4" size={56} />
          <div className="font-display font-extrabold text-2xl mb-1">Destaque ativo</div>
          <p className="text-sm text-zinc-600 mb-6">
            <span className="font-bold">{d.target_name}</span> está em destaque {parent ? "por mais" : "durante"} <span className="font-bold">{d.featured_plan} dias</span>
            {until && <> — até <span className="font-bold">{new Date(until).toLocaleDateString("pt-PT")}</span></>}.<br />Enviámos-te o recibo por email.
          </p>
          <div className="flex flex-col gap-2">
            <Link to={d.path} data-testid="featured-success-view" className="w-full py-3 rounded-xl bg-black text-white font-semibold hover:bg-[#c8102e] transition-colors flex items-center justify-center gap-2"><Sparkles size={14} /> Ver o meu conteúdo</Link>
            <Link to="/destaques" data-testid="featured-success-mine" className="text-xs text-zinc-500 hover:text-black py-2">Os meus destaques</Link>
          </div>
        </>)}
        {state.status === "timeout" && (<>
          <Loader2 className="mx-auto text-zinc-400 mb-4" size={48} />
          <div className="font-display font-bold text-lg mb-2">Ainda a aguardar a confirmação da Stripe</div>
          <p className="text-sm text-zinc-500 mb-6">O pagamento pode demorar alguns instantes a ser confirmado. O destaque ativa automaticamente quando a confirmação chegar — não precisas de pagar outra vez.</p>
          <Link to="/destaques" className="text-xs text-[#c8102e] font-semibold hover:underline">Ver os meus destaques →</Link>
        </>)}
        {(state.status === "failed" || state.status === "error") && (<>
          <div className="font-display font-bold text-lg mb-2">Não conseguimos confirmar este pagamento</div>
          <p className="text-sm text-zinc-500 mb-6">Se o valor foi debitado, escreve-nos para support@angolauk.co.uk com a data e o conteúdo.</p>
          <Link to="/destaques" className="text-xs text-[#c8102e] font-semibold hover:underline">Os meus destaques →</Link>
        </>)}
      </div>
    </div>
  );
}
